import script from "./LastGradeUpdateCell.vue?vue&type=script&setup=true&lang=js"
export * from "./LastGradeUpdateCell.vue?vue&type=script&setup=true&lang=js"

import "./LastGradeUpdateCell.vue?vue&type=style&index=0&id=3095ecaa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3095ecaa"]])

export default __exports__